export const APPLICATION_VERSION = process.env.VERSION;
export const APPLICATION_PHASE = process.env.APPLICATION_PHASE || 'REAL';

//export const RTMP_URL = process.env.RTMP_URL;

export const FILE_URL = process.env.FILE_URL;

export const PAGINATION = {
    first: true,
    last: false,
    numberOfElements: 4,
    main_numberOfElements: 4,
    td_numberOfElements: 8,
    size: 10,
    number: 1,
    totalPages: 0,
    totalElements: 1
};
export const TUNNEL_CONSTRUCTION = {
    NATM: '017001',
    TBM: '017002'
};
export const COMM_CODE = {
    tunnelConstruction: '017',
    measureLocation: '010',
    rockType: '013',
    measurePosition: '015',
    rockName: '014',
    constructionName: '016'
};
export const AUTH = {
    admin: 'admin'
};

export const TD_IMG = {
    plane: 'plane.jpg',
    verticalPlane: 'section.jpg',
    section: 'section2.jpg'
};

export const NO_IMG = 'images/common/noimage.png';

export const TD_IMG_URL = FILE_URL + '/three-dimentional/';

/** 너무 세분화하지 말고 HEADER 를 구분하는 정도
 *  default :: json string
 'Access-Control-Allow-Origin': '*',
 'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE,OPTIONS'
 */
export const DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
/*
export const FIELD_PAGE = 'page';
export const FIELD_SIZE = 'size';
*/

/* component별 사이즈 정리 */
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_ROUTE = '/';

export const MEMBER_ID = 'memberId';
export const NAME = 'name';
export const CONSTRUCTION_NM = 'constructionNm';
export const CONSTRUCTION = 'construction';
export const TYPE = 'type';
export const JWT_TOKEN = 'token';
export const JWT_REFRESH_TOKEN = 'refreshtoken';

export const AUTO_YN = 'autoYn';

export const PARAM_OBJECT = 'paramObject';

/* APP 관련 */
export const PICTURE_SORCE_TYPE = {
    PHOTOLIBRARY: 0,
    CAMERA: 1
};

export const PICTURE_MEDIA_TYPE = {
    PICTURE: 0,
    VIDEO: 1
};

/*
Cordova 관련 설정
*/
export const CORDOVA_SRC = 'cordova.js';

/*
Device 관련 설정
*/

/*
평문전송을 위한 암호 key
*/
export const SECRET_KEY = 'dwcdslivea111111111111';
